module.exports = __webpack_public_path__ + "static/media/logo_pharmgenetix_einzeilig.999cd17e.svg";